import { GET_ALL_APPOINTMENT_SUCCESS, APPEND_APPOINTMENT_LIST } from "../actions/patientAction"
import { uniqueArrayById } from "../utils/helpers"

const getAllAppointmentReducer = (state = [], { type,  data = [] }) => {
  switch (type) {
    case GET_ALL_APPOINTMENT_SUCCESS:
      return data
    case APPEND_APPOINTMENT_LIST:
      return uniqueArrayById([...state, ...data])
    default:
      return state
  }
}

export default getAllAppointmentReducer